import React from 'react';
import { connect } from 'react-redux';
import { ObservationPosturePeds } from './ObservationPosturePeds'
import { getPanels } from '_helpers';


const components = {

}

class PatientCareCenterNoteObjectiveObsPosturePeds extends React.Component {

    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} />;
    }

    render() {

        return (
            <ObservationPosturePeds />
        );

    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let panels = getPanels(noteId, 'Observation', 'Pediatric');

    return {
        noteId: noteId,
        panels
    };
}

const connectedPatientCareCenterNoteObjectiveObsPosturePeds = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsPosturePeds);
export { connectedPatientCareCenterNoteObjectiveObsPosturePeds as PatientCareCenterNoteObjectiveObsPosturePeds };

